export const getWidgetToken = (search: string) => {
    try {
        const url = search.substring(1);
        const qArray = url.split('&');

        for (const item of qArray) {
            const pArr = item.split('=');
            if (pArr[0] === 'token') {
                return pArr[1];
            }
        }

        return '';
    } catch {
        return '';
    }
};
